export const IS_LOGO_TEXT_SEPARATED = Boolean(
  window.APP_CEMETERY_LOGO_TITLE || window.APP_CEMETERY_LOGO_SUBTITLE,
);

export enum LogoTextLocation {
  BOTTOM = 'bottom',
  SIDE = 'side',
}
